import { FC } from 'react';
import ProTree, { TreeProps } from './tree';
import ProTreeNode, { TreeNodeProps } from './treeNode';
import ProDirectoryTree, { DirectoryTreeProps } from './directoryTree';

export type ITreeComponent = FC<
  TreeProps & React.RefAttributes<HTMLElement>
> & {
  TreeNode: FC<TreeNodeProps>;
  DirectoryTree: FC<DirectoryTreeProps>;
};

const TransTree = ProTree as ITreeComponent;
TransTree.TreeNode = ProTreeNode;
TransTree.DirectoryTree = ProDirectoryTree;

export default TransTree;
